import React from "react";
import { Box, Typography, Grid, Button, Container } from "@mui/material";
import { motion } from "framer-motion";
import { useAppConfig } from "../../context/AppConfigContext";
import { useNavigate } from "react-router-dom";

const ProductShowcase = () => {
  const { config } = useAppConfig();
  const products = config?.landingPage.productShowcase || [];
  const navigate = useNavigate();

  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Box sx={{ display: "inline-block", position: "relative" }}>
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{
              fontFamily: "Moul",
              mb: 1,
            }}>
            What We Bake, What We Do
          </Typography>
          <Box
            sx={{
              width: 60,
              height: 4,
              backgroundColor: "#FF6F61",
              borderRadius: 2,
              mx: "auto",
            }}
          />
        </Box>
      </Container>

      {products.map((product, index) => (
        <Box
          key={index}
          sx={{
            width: "100%",
            backgroundColor: index % 2 === 1 ? "#FAF6F4" : "transparent",
          }}>
          <Container maxWidth="lg">
            <Grid
              container
              spacing={4}
              direction={index % 2 === 0 ? "row" : "row-reverse"}
              alignItems="center"
              justifyContent="center"
              sx={{ py: { xs: 6, md: 10 } }}>
              <Grid item xs={12} md={6}>
                <Box sx={{ width: "100%", overflowX: "clip" }}>
                  {" "}
                  <motion.div
                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}>
                    <Box sx={{ position: "relative" }}>
                      <Box
                        component="img"
                        src={product.image}
                        alt={product.title}
                        sx={{
                          width: "100%",
                          height: { xs: 350, md: 550 },
                          objectFit: "cover",
                          borderRadius: 4,
                          boxShadow: 3,
                          filter: product.available ? "none" : "grayscale(40%)",
                          opacity: product.available ? 1 : 0.85,
                        }}
                      />
                      {!product.available && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 16,
                            left: 16,
                            backgroundColor: "#FF6F61",
                            color: "#fff",
                            fontWeight: "bold",
                            px: 1.5,
                            py: 0.5,
                            borderRadius: 2,
                            fontSize: "0.85rem",
                            boxShadow: 2,
                          }}>
                          Page Coming Soon
                        </Box>
                      )}
                    </Box>
                  </motion.div>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={{ width: "100%", overflowX: "clip" }}>
                  <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 }}>
                    {product.tagline && (
                      <Typography
                        variant="subtitle2"
                        sx={{
                          textTransform: "uppercase",
                          letterSpacing: "1px",
                          color: "#FF6F61",
                          mb: 1,
                          fontWeight: 500,
                        }}>
                        {product.tagline}
                      </Typography>
                    )}
                    <Typography
                      variant="h4"
                      fontWeight="bold"
                      sx={{ mb: 2, fontFamily: "Inter" }}>
                      {product.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "1.3rem",
                        lineHeight: 1.9,
                        color: "#707070",
                        mb: 3,
                      }}>
                      {product.description}
                    </Typography>

                    {product.available && (
                      <Button
                        variant="outlined"
                        onClick={() => navigate(product.url)}
                        sx={{
                          borderColor: "#FF6F61",
                          color: "#FF6F61",
                          textTransform: "none",
                          fontWeight: 500,
                          "&:hover": {
                            borderColor: "#fd7762cc",
                            color: "#fd7762cc",
                          },
                        }}>
                        Learn More
                      </Button>
                    )}
                  </motion.div>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      ))}
    </Box>
  );
};

export default ProductShowcase;
